import { GET } from 'helpers/api'

/**
 * SHIKOYAT BOTI — 80 mm chek pastidagi QR uchun.
 *
 * Naqsh `helpers/chequeNotes.js` bilan bir xil: kirishda bir marta yuklanadi,
 * localStorage ga yoziladi va chop etish paytida SINXRON o'qiladi.
 *
 * ⚠️ NEGA SINXRON: chek `useReactToPrint` bilan darhol chiqadi. Agar bot nomi
 *    so'rov bilan olinsa, birinchi chekda QR ulgurmay bo'sh chiqardi.
 */

const STORAGE_KEY = 'complaint_bot'

let cache = null

function readCache() {
	if (cache) return cache
	try {
		const raw = localStorage.getItem(STORAGE_KEY)
		if (raw) {
			cache = JSON.parse(raw)
			return cache
		}
	} catch (e) { /* jim */ }
	return null
}

function writeCache(username) {
	cache = { username: username || '' }
	try {
		localStorage.setItem(STORAGE_KEY, JSON.stringify(cache))
	} catch (e) { /* jim */ }
	return cache
}

/** Bazadan yuklaydi (Login.js dan va Cheque80 ochilganda chaqiriladi) */
export async function loadComplaintBot() {
	try {
		const res = await GET('/helper/complaint-bot', {}, { loader: false })
		if (res && res.status >= 200 && res.status < 300) {
			return writeCache(res.data?.bot_username)
		}
	} catch (e) { /* jim */ }
	return cache
}

/** Bot nomi (@ siz). Sozlanmagan bo'lsa null — chekda QR bloki umuman chiqmaydi. */
export function getComplaintBot() {
	const c = readCache()
	const name = c && c.username ? String(c.username).trim() : ''
	return name || null
}

/** QR ichiga yoziladigan havola */
export function getComplaintBotUrl() {
	const name = getComplaintBot()
	return name ? 'https://t.me/' + name : null
}
